var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#deleteIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.85714 18.2222C6.85714 19.2 7.62857 20 8.57143 20H15.4286C16.3714 20 17.1429 19.2 17.1429 18.2222V7.55556H6.85714V18.2222ZM9.57429 12.5244C9.24 12.1778 9.24 11.6178 9.57429 11.2711C9.90857 10.9244 10.4486 10.9244 10.7829 11.2711L12 12.5244L13.2086 11.2711C13.5429 10.9244 14.0829 10.9244 14.4171 11.2711C14.7514 11.6178 14.7514 12.1778 14.4171 12.5244L13.2086 13.7778L14.4171 15.0311C14.7514 15.3778 14.7514 15.9378 14.4171 16.2844C14.0829 16.6311 13.5429 16.6311 13.2086 16.2844L12 15.0311L10.7914 16.2844C10.4571 16.6311 9.91714 16.6311 9.58286 16.2844C9.24857 15.9378 9.24857 15.3778 9.58286 15.0311L10.7914 13.7778L9.57429 12.5244ZM17.1429 4.88889H15L14.3914 4.25778C14.2371 4.09778 14.0143 4 13.7914 4H10.2086C9.98571 4 9.76286 4.09778 9.60857 4.25778L9 4.88889H6.85714C6.38571 4.88889 6 5.28889 6 5.77778C6 6.26667 6.38571 6.66667 6.85714 6.66667H17.1429C17.6143 6.66667 18 6.26667 18 5.77778C18 5.28889 17.6143 4.88889 17.1429 4.88889Z",
    fill: "#FF6B72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "deleteIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.ec006fcbce0dfdd2451c07eb4d7f2571.svg";
export { ForwardRef as ReactComponent };